// import React from 'react';
// import { CheckCircle, Users } from 'lucide-react';
// import './Home1.css';
// import backhoe from '../Images/Backhoe.jpg'
// import Compactor from '../Images/Compactor-Spares.jpeg'
// import Excavators from '../Images/Excavators.webp'
// import Skidsteer from '../Images/Skid-Steer.png'
// // import backhoe from '../Images/Backhoe.jpg'





// const HomePage = () => {
//   const productCategories = [
//     {
//       title: "JCB Spare Parts",
//       image: backhoe,
//       items: [
//         "Hydraulic pumps, seals, cylinders",
//         "Engine overhaul kits & fuel systems",
//         "Control valves, filters & hoses",
//         "Electrical parts, switches, sensors"
//       ]
//     },
//     {
//       title: "Backhoe Loader Components",
//       image: backhoe,
//       items: [
//         "Transmission parts",
//         "Axle kits & drive shafts",
//         "Bucket teeth & side cutters",
//         "Steering units & linkages"
//       ]
//     },
//     {
//       title: "Excavator Parts",
//       image: Excavators,
//       items: [
//         "Track chains, rollers, sprockets",
//         "Slewing bearings, motors",
//         "Cab interiors, panels & controls",
//         "Boom, dipper, and bucket spares"
//       ]
//     },
//     {
//       title: "Compactor Spares",
//       image: Compactor,
//       items: [
//         "Vibration motors & isolators",
//         "Drum bearings & hydraulic drives",
//         "Mount kits & brake systems"
//       ]
//     },
//     {
//       title: "Skid Steer Loader Parts",
//       image: Skidsteer,
//       items: [
//         "Loader arms & cylinder assemblies",
//         "Tires, rubber tracks",
//         "Starter motors, alternators, wiring",
//         "Control joysticks & cabin parts"
//       ]
//     }
//   ];

//   const clientTypes = [
//     "Construction contractors",
//     "Equipment rental companies",
//     "Infrastructure development firms"
//   ];

//   return (
//     <div className="home-page">
//       {/* Hero Section */}
//       <div className="hero-section">
//         <div className="hero-overlay"></div>
//         <div className="hero-content">
//           <div className="hero-text">
//             <h1 className="hero-title">
//               One Stop Solution for
//               <span className="hero-highlight">Heavy Equipment Spare Parts</span>
//             </h1>
//             <p className="hero-description">
//               We are your trusted partner in supplying <strong>high-performance spare parts and components</strong> for leading construction and earthmoving machines. From <strong>JCB and Backhoe Loaders</strong> to <strong>Excavators, Compactors, and Skid Steer Loaders</strong>, we ensure unmatched product quality, timely delivery, and excellent customer support.
//             </p>
//             <button className="hero-cta">
//               Get Quote Now
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Product Range Section */}
//       <div className="products-section">
//         <div className="section-container">
//           <div className="section-header">
//             <h2 className="section-title">
//               🔧 Our Product Range
//             </h2>
//           </div>

//           <div className="products-grid">
//             {productCategories.map((category, index) => (
//               <div key={index} className="product-card">
//                 <div className="product-image-container">
//                   <img
//                     src={category.image}
//                     alt={category.title}
//                     className="product-image"
//                   />
//                   <div className="product-overlay">
//                     <div className="product-details">
//                       <h3 className="product-title">
//                         <CheckCircle className="product-icon" />
//                         {category.title}
//                       </h3>
//                       <ul className="product-list">
//                         {category.items.map((item, itemIndex) => (
//                           <li key={itemIndex} className="product-item">
//                             <span className="bullet">•</span>
//                             {item}
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="product-footer">
//                   <h4 className="product-name">{category.title}</h4>
//                   {/* <p className="hover-instruction">Hover to see details</p> */}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* We Serve Section */}
//       <div className="serve-section">
//         <div className="section-container">
//           <div className="section-header">
//             <h2 className="section-title">
//               🌍 We Serve
//             </h2>
//             <p className="section-description">
//               We proudly serve a wide customer base including:
//             </p>
//             <div className="clients-grid">
//               {clientTypes.map((client, index) => (
//                 <div key={index} className="client-card">
//                   <Users className="client-icon" />
//                   <h3 className="client-title">{client}</h3>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HomePage;



import React, { useState, useEffect } from 'react';
import { CheckCircle, Users, ChevronLeft, ChevronRight } from 'lucide-react';
import './Home.css';
import backhoe from '../Images/Backhoe.jpg'
import Compactor from '../Images/Compactor-Spares.jpeg'
import Excavators from '../Images/Excavators.webp'
import Skidsteer from '../Images/Skid-Steer.png'
import jcbspare from '../Images/jcb-spare.jpg'
import front1 from '../Images/front1.jpg'
import front2 from '../Images/front2.jpg'
import front3 from '../Images/various-work-tools-worktop.jpg'



const HomePage = () => {

  // Hero slider images
  const heroImages = [
    {
      src: front1,
      alt: "JCB Backhoe Loader"
    },
    {
      src: front3,
      alt: "JCB Backhoe Loader"
    },
    {
      src: front2,
      alt: "Heavy Excavators"
    }
    // {
    //   src: Compactor,
    //   alt: "Road Compactor"
    // },
    // {
    //   src: Skidsteer,
    //   alt: "Skid Steer Loader"
    // }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-advance slider
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(slideInterval);
  }, [heroImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const productCategories = [
    {
      title: "JCB Spare Parts",
      image: jcbspare,
      items: [
        "Hydraulic pumps, seals, cylinders",
        "Engine overhaul kits & fuel systems",
        "Control valves, filters & hoses",
        "Electrical parts, switches, sensors"
      ]
    },
    {
      title: "Backhoe Loader Components",
      image: backhoe,
      items: [
        "Transmission parts",
        "Axle kits & drive shafts",
        "Bucket teeth & side cutters",
        "Steering units & linkages"
      ]
    },
    {
      title: "Excavator Parts",
      image: Excavators,
      items: [
        "Track chains, rollers, sprockets",
        "Slewing bearings, motors",
        "Cab interiors, panels & controls",
        "Boom, dipper, and bucket spares"
      ]
    },
    {
      title: "Compactor Spares",
      image: Compactor,
      items: [
        "Vibration motors & isolators",
        "Drum bearings & hydraulic drives",
        "Mount kits & brake systems"
      ]
    },
    {
      title: "Skid Steer Loader Parts",
      image: Skidsteer,
      items: [
        "Loader arms & cylinder assemblies",
        "Tires, rubber tracks",
        "Starter motors, alternators, wiring",
        "Control joysticks & cabin parts"
      ]
    }
  ];

  const clientTypes = [
    "Construction contractors",
    "Equipment rental companies",
    "Infrastructure development firms"
  ];

  return (
    <div className="home-page">
      {/* Hero Section with Slider */}
      <div className="hero-section">
        <div className="hero-slider">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="hero-slide-image"
              />
            </div>
          ))}

          {/* Navigation arrows */}
          <button className="slider-nav prev" onClick={prevSlide}>
            <ChevronLeft className="nav-icon" />
          </button>
          <button className="slider-nav next" onClick={nextSlide}>
            <ChevronRight className="nav-icon" />
          </button>

          {/* Slide indicators */}
          <div className="slider-indicators">
            {heroImages.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>

        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              One Stop Solution for
              <span className="hero-highlight">Heavy Equipment Spare Parts</span>
            </h1>
            <p className="hero-description">
              We are your trusted partner in supplying <strong>high-performance spare parts and components</strong> for leading construction and earthmoving machines. From <strong>JCB and Backhoe Loaders</strong> to <strong>Excavators, Compactors, and Skid Steer Loaders</strong>, we ensure unmatched product quality, timely delivery, and excellent customer support.
            </p>
            {/* <button className="hero-cta">
              Get Quote Now
            </button> */}
          </div>
        </div>
      </div>

      {/* Product Range Section */}
      <div className="products-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">
              🔧 Our Product Range
            </h2>
          </div>

          <div className="products-grid">
            {productCategories.map((category, index) => (
              <div key={index} className="product-card">
                <div className="product-image-container">
                  <img
                    src={category.image}
                    alt={category.title}
                    className="product-image"
                  />
                  <div className="product-overlay">
                    <div className="product-details">
                      <h3 className="product-title">
                        <CheckCircle className="product-icon" />
                        {category.title}
                      </h3>
                      <ul className="product-list">
                        {category.items.map((item, itemIndex) => (
                          <li key={itemIndex} className="product-item">
                            <span className="bullet">•</span>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="product-footer">
                  <h4 className="product-name">{category.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* We Serve Section */}
      <div className="serve-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">
               We Serve
            </h2>
            <p className="section-description">
              We proudly serve a wide customer base including:
            </p>
            <div className="clients-grid">
              {clientTypes.map((client, index) => (
                <div key={index} className="client-card">
                  <Users className="client-icon" />
                  <h3 className="client-title">{client}</h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
